import React, { useState } from 'react';
import { useAuthStore } from '../../stores/authStore';
import { skipAuth } from '../../lib/firebase';

export function LoginScreen() {
  const [mode, setMode] = useState<'signin' | 'signup'>('signin');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { signIn, signUp, signInWithGoogle, error, clearError, loading } = useAuthStore();
  const useLocalAuth = skipAuth;

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (mode === 'signin') {
      await signIn(email, password);
    } else {
      await signUp(email, password);
    }
  }

  return (
    <div className="login-screen">
      <div className="login-card">
        <h1 className="login-logo">&#9824; Range Reader</h1>
        <p className="login-subtitle">Poker range training</p>

        <form onSubmit={handleSubmit} className="login-form">
          <input
            type={useLocalAuth ? 'text' : 'email'}
            placeholder="Email"
            value={email}
            onChange={(e) => { setEmail(e.target.value); clearError(); }}
            className="login-input"
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => { setPassword(e.target.value); clearError(); }}
            className="login-input"
            required
            minLength={6}
          />

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="btn-login primary" disabled={loading}>
            {mode === 'signin' ? 'Sign In' : 'Create Account'}
          </button>
        </form>

        {!useLocalAuth && (
          <button
            className="btn-login google"
            onClick={signInWithGoogle}
            disabled={loading}
          >
            Sign in with Google
          </button>
        )}

        <div className="login-toggle">
          {mode === 'signin' ? (
            <span>
              No account?{' '}
              <button className="link-btn" onClick={() => { setMode('signup'); clearError(); }}>
                Sign up
              </button>
            </span>
          ) : (
            <span>
              Have an account?{' '}
              <button className="link-btn" onClick={() => { setMode('signin'); clearError(); }}>
                Sign in
              </button>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
